import React from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';

import FileInput from 'components/form/FileInput';
import { iconSelect } from 'utils/iconSelect';

import Paper from 'material-ui/Paper';
import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CircularProgress from 'material-ui/CircularProgress';

import { FormattedMessage } from 'react-intl';
import pallet from '../constants/colors';

const styles = {
  paper: {
    padding: 16,
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 350,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  fileInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
};

const validate = (values) => {
  const errors = {};

  if (!values.fileType) {
    errors.fileType = <FormattedMessage id="repository.errorType" />;
  }

  if (!values.file) {
    errors.file = 'NO_FILE';
  } else if (values.file.size > 11000000) {
    /* eslint no-underscore-dangle: 0 */
    errors._error = <FormattedMessage id="repository.errorSize" />;
  }

  return errors;
};

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
    };
  }

  render() {
    const {
      fileName,
    } = this.state;
    const {
      handleSubmit,
      selectOptions,
      uploading,
      invalid,
      // _error from form validation
      error,
    } = this.props;

    const options = selectOptions.map(({ FileRepositoryObjectDocumentTypeID, Name }) =>
      (<MenuItem
        value={FileRepositoryObjectDocumentTypeID}
        key={`${Name}${FileRepositoryObjectDocumentTypeID}`}
        primaryText={Name}
        data-cy={Name}
      />));

    return (
      <form onSubmit={handleSubmit}>
        <Paper style={styles.paper}>
          <RaisedButton
            fullWidth
            style={{ marginBottom: 8 }}
            label={fileName || <FormattedMessage id="repository.chooseFile" />}
            secondary={!fileName}
            icon={<FontIcon className="material-icons">{fileName ? iconSelect(fileName) : 'file_upload' }</FontIcon>}
            containerElement="label"
            disabled={uploading}
          >
            <Field
              name="file"
              type="file"
              component={FileInput}
              style={styles.fileInput}
              onChange={(e, file) => this.setState({ fileName: file ? file.name : '' })}
            />
          </RaisedButton>
          {error && <span style={{ color: pallet.errorColor }}>{error}</span>}
          <Field
            name="fileType"
            component={({ input, meta }) => (
              <SelectField
                {...input}
                errorText={meta.touched && meta.error}
                style={{ marginBottom: 16 }}
                onChange={(event, index, value) => input.onChange(value)}
                hintText={<FormattedMessage id="repository.fileType" />}
                disabled={uploading}
                data-cy="select-file-type"
              >
                {options}
              </SelectField>
            )}
          />
          <div style={{
              display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-end',
            }}
          >
            {uploading && <CircularProgress style={{ marginRight: 16, lineHeight: '24px' }} size={24} thickness={2} />}
            <RaisedButton
              style={{ alignSelf: 'flex-end' }}
              label={<FormattedMessage id="repository.save" />}
              type="submit"
              disabled={uploading || invalid}
              primary
              icon={<FontIcon className="material-icons">save</FontIcon>}
            />
          </div>
        </Paper>
      </form>
    );
  }

}

FileUpload.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  uploading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    FileRepositoryObjectDocumentTypeID: PropTypes.number,
    Name: PropTypes.string,
  })),
};

export default reduxForm({
  form: 'fileUpload',
  validate,
})(FileUpload);



// WEBPACK FOOTER //
// ./src/components/FileUpload.js